import { WhichWeightAPI } from 'WhichWeightAPI'
import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ExerciseVideo from 'components/Exercise/ExerciseVideo'

export default function ExpandedExerciseData() {
    const location = useLocation()
    const { exercise } = location.state

    const [exerciseTextInstructions, setExerciseTextInstructions] = useState(null)

    const GetExerciseInstructionsFromBackend = async () => {

        const jsonBody = {
            exerciseId: exercise.id,
        }

        const result = await WhichWeightAPI('CORE', 'GET', '/exercise_instructions', jsonBody)

        // console.log(result.data.data);

        setExerciseTextInstructions(result.data.data.textInstructions.split('\n'))

        /*
        const csvData = result.data.csvData

        if (csvData) {
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
            const link = document.createElement('a')
            const url = URL.createObjectURL(blob)

            link.setAttribute('href', url)
            link.setAttribute('download', 'exercise-instructions.csv')
            link.style.visibility = 'hidden'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        }
        */
    }

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top when component mounts
        GetExerciseInstructionsFromBackend()
    }, [])

    return (
        <ScreenFrame>
            <div className="flex items-center gap-4 border-b border-gray-200 pb-4">
                <img 
                    src={exercise.imageUrl} 
                    alt="Exercise Thumbnail" 
                    className="w-24 h-24 object-cover rounded-lg" 
                />
                
                <h1 className="text-3xl text-gray-900">{exercise.name}</h1>
            </div>

            <h2 className="text-xl font-semibold text-gray-900">Video Instructions</h2>

            <div className='grid grid-cols-10 gap-4'>

                <div className='col-span-3 grid h-full'>
                    <ExerciseVideo exercise={exercise} />
                </div>
            
                <div className="col-span-7 relative overflow-hidden rounded-lg border border-gray-200 shadow-sm">
                    <video 
                        className="w-full aspect-video object-cover"
                        controls
                        preload="metadata"
                    >
                        <source src={exercise.videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>

            <h2 className="text-xl font-semibold text-gray-900">Text Instructions</h2>

            {exerciseTextInstructions === null && 
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
            }

            {exerciseTextInstructions !== null && 
                <div className="rounded-lg border border-gray-200 bg-white shadow-sm px-6 py-4 space-y-2">
                    {exerciseTextInstructions?.map((instruction, index) => (
                        instruction.trim() && (
                            <div 
                                key={index} 
                                className="text-sm text-gray-700 leading-relaxed"
                            >
                                {instruction}
                            </div>
                        )
                    ))}
                </div>
            }

            <h2 className="text-xl font-semibold text-gray-900">Exercise Details</h2>

            <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                <div className="divide-y divide-gray-200">
                    {Object.entries(exercise).map(([key, value]) => (
                        <div key={key} className="px-6 py-3">
                            <dt className="text-sm font-medium text-gray-500 capitalize">
                                {key.replace(/([A-Z])/g, ' $1').trim()}
                            </dt>
                            <dd className="mt-1 text-sm text-gray-900">
                                {typeof value === 'string' ? value : JSON.stringify(value)}
                            </dd>
                        </div>
                    ))}
                </div>
            </div>
        </ScreenFrame>
    )
}
